// extracted by mini-css-extract-plugin
export default {"NavLogo":"NavLogo_NavLogo__Ie8Wj"};